import { render, staticRenderFns } from "./ProductsRow.vue?vue&type=template&id=a51b77b0&scoped=true&"
import script from "./ProductsRow.vue?vue&type=script&lang=js&"
export * from "./ProductsRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRow.vue?vue&type=style&index=0&id=a51b77b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51b77b0",
  null
  
)

export default component.exports